import BaseApiService from "@/api/BaseApiService"
import proxy from "@/api/proxy"
import { RoomTypes } from "./RoomTypes"

const HotelV2Service = {
  GetHotel(hotelId: string): Promise<any> {
    return BaseApiService.getAsync(proxy.HotelV2, `Hotel?id=${encodeURIComponent(hotelId)}&fromArchive=true`)
  },
  GetRoomTypes(hotelId: string): Promise<RoomTypes[]> {
    return BaseApiService.getAsync(proxy.HotelV2, `RoomType/Hotel/${encodeURIComponent(hotelId)}`)
  },
}

export default HotelV2Service
